<div class="fixed inset-y-1/4 inset-x-1/4 w-1/2 pointer-events-none">
  <div
    class="
      modal-content
      border-none
      shadow-lg
      relative
      flex
      flex-col
      w-full
      pointer-events-auto
      bg-white
      bg-clip-padding
      rounded-md
      outline-none
      text-current">
    <ng-content></ng-content>
  </div>
</div>
